export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9080.f9c25f26.jpg";